// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1hkjO","content":"RecentSearches_content__3J0Jz"};